<template>
  <div v-if="openAfterResponse">
    <my-user-account v-if="roles.includes('admin') || roles.includes('user')"></my-user-account>
    <my-company-account v-else></my-company-account>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import VueJwtDecode from 'vue-jwt-decode'
import MyCompanyAccount from './components/MyCompanyAccount'
import MyUserAccount from './components/MyUserAccount'
function decodeJwtToken () {
  let token = localStorage.getItem('token')
  if (token) {
    return VueJwtDecode.decode(token).permissions
  }
  return []
}
export default {
  name: 'MyAccount',
  props: [],
  components: {
    MyCompanyAccount,
    MyUserAccount
  },
  data: () => ({
  }),
  computed: {
    roles: () => decodeJwtToken(),
    ...mapState({
      openAfterResponse: state => state.auth.openAfterResponse
    })
  }
}
</script>

<style lang="scss" scoped >
  @import "../../assets/sass/desktop/myAccount.scss";
</style>



// WEBPACK FOOTER //
// src/components/profilePage/MyAccount.vue